import { userReducer } from "./userReducer";
import { announcementReducer } from "./announcementReducer";
import { globalReducer } from "./globalReducer";
import { groupReducer } from "./groupReducer";
import { homeReducer } from "./homeReducer";
import { scheduleReducer } from "./scheduleReducer";
import { viewerReducer } from "./viewerReducer";
import { organizationReducer } from "./organizationReducer";
import { jobHistoryReducer } from "./jobHistoryReducer";
import { contentUploadReducer } from "./contentUploadReducer";

import { cmsReducer } from "./cmsReducer";
import { reportingReducer } from "./reportingReducer";
import { assetReducer } from "./assetReducer";

const appReducers = {
  user: userReducer,
  global: globalReducer,
  home: homeReducer,
  schedule: scheduleReducer,
  group: groupReducer,
  viewer: viewerReducer,
  announcement: announcementReducer,
  organization: organizationReducer,
  jobHistory: jobHistoryReducer,
  contentUpload: contentUploadReducer,
  cms: cmsReducer,
  reporting: reportingReducer,
  asset: assetReducer,
};

export default appReducers;
